import { Grid } from '@mui/material'
import React from 'react'
import AddEditNotification from './AddEditNotification'
import NotificationList from './NotificationList'

const NotificationDashboard = () => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={5}>
          <AddEditNotification/>
      </Grid>
      <Grid item xs={12} md={7}>
        <NotificationList/>
      </Grid>
    </Grid>
  )
}

export default NotificationDashboard